import { render, staticRenderFns } from "./VoiceSelector.vue?vue&type=template&id=2687e918&scoped=true&lang=pug&"
import script from "./VoiceSelector.vue?vue&type=script&lang=js&"
export * from "./VoiceSelector.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSelector.vue?vue&type=style&index=0&id=2687e918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687e918",
  null
  
)

export default component.exports